import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { Component } from 'react'
import TextInput from '../../inputs/text'

/**
 * Edit Panel - Content URL: Controls
 * the content URL input in the GIF
 * Edit Panel. This input can be shown
 * or hidden as an advanced option.
 *
 * @class EditPanelContentURL
 */
export default class extends Component {
    static propTypes = {
        className: PropTypes.string,
        value: PropTypes.string,
        onChange: PropTypes.func.isRequired,
    }
    render() {
        const { className, value, onChange } = this.props
        return (
            <div className={className}>
                <TextInput
                    type="url"
                    value={value}
                    placeholder="Add a content URL"
                    buttonLabel="Save"
                    onSubmit={onChange}
                />
            </div>
        )
    }
}
